import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

function ValorEstoquePDF(produtos) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const dataAtual = new Date().toLocaleDateString('pt-BR');

  const reportTitle = [
    {
      text: 'Relatório de Valor do Estoque',
      fontSize: 15,
      alignment: 'center',
      bold: true,
      margin: [0, 20, 0, 4]
    },
    {
      text: `Data do relatório: ${dataAtual}`,
      fontSize: 10,
      alignment: 'center',
      margin: [0, 0, 0, 20]
    }
  ];

  let totalEstoque = 0;

  const dados = produtos.map((produto) => {
    const estoque = Number(produto.ESTOQUE);
    const compra = Number(produto.COMPRA);
    const venda = Number(produto.VENDA);

    const valorCompra = compra * estoque;
    const valorVenda = venda * estoque;
    const lucro = valorVenda - valorCompra;

    const icms = (lucro * Number(produto.ICMS_IN || 0)) / 100;
    const pis = (lucro * Number(produto.ALI_PIS_DEBITO || 0)) / 100;
    const cofins = (lucro * Number(produto.ALI_COFINS_DEBITO || 0)) / 100;

    totalEstoque += estoque;

    return [
      { text: produto.COD_PRODUTO, fontSize: 9, margin: [0, 2], alignment: 'center' },
      { text: produto.DESCRICAO, fontSize: 9, margin: [0, 2] },
      { text: produto.UNIDADE, fontSize: 9, margin: [0, 2], alignment: 'center' },
      { text: estoque.toFixed(3), fontSize: 9, margin: [0, 2], alignment: 'right' },
      { text: 'R$ ' + valorCompra.toFixed(2), fontSize: 9, margin: [0, 2], alignment: 'right' },
      { text: 'R$ ' + valorVenda.toFixed(2), fontSize: 9, margin: [0, 2], alignment: 'right' },
      { text: 'R$ ' + icms.toFixed(2), fontSize: 9, margin: [0, 2], alignment: 'right' },
      { text: 'R$ ' + pis.toFixed(2), fontSize: 9, margin: [0, 2], alignment: 'right' },
      { text: 'R$ ' + cofins.toFixed(2), fontSize: 9, margin: [0, 2], alignment: 'right' }
    ];
  });

  const tableHeader = [
    { text: 'Código', style: 'tableHeader', fontSize: 10 },
    { text: 'Nome', style: 'tableHeader', fontSize: 10 },
    { text: 'Un.', style: 'tableHeader', fontSize: 10, alignment: 'center' },
    { text: 'Estoque', style: 'tableHeader', fontSize: 10, alignment: 'right' },
    { text: 'Valor Compra', style: 'tableHeader', fontSize: 10, alignment: 'right' },
    { text: 'Valor Venda', style: 'tableHeader', fontSize: 10, alignment: 'right' },
    { text: 'ICMS', style: 'tableHeader', fontSize: 10, alignment: 'right' },
    { text: 'PIS', style: 'tableHeader', fontSize: 10, alignment: 'right' },
    { text: 'COFINS', style: 'tableHeader', fontSize: 10, alignment: 'right' }
  ];

  const details = [
    {
      table: {
        headerRows: 1,
        widths: [80, "*", 40, 60, 80, 70, 50, 50, 50], 
        body: [tableHeader, ...dados]
      },
      layout: 'lightHorizontalLines'
    }
  ];

  function Rodape(currentPage, pageCount) {
    return {
      text: `${currentPage} / ${pageCount}`,
      alignment: 'right',
      fontSize: 9,
      margin: [0, 10, 20, 0]
    };
  }

  const docDefinitions = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [15, 50, 15, 40],
    header: reportTitle,
    content: details,
    footer: Rodape,
    styles: {
      tableHeader: {
        bold: true,
        fillColor: '#eeeeee',
        color: 'black',
        margin: [0, 3, 0, 3]
      }
    }
  };

  pdfMake.createPdf(docDefinitions).open();
}

export default ValorEstoquePDF;
